import { HabitSchedule, Timestamp } from '@griply/types';
import { isAfter, isBefore } from 'date-fns';

import { getActiveSchedule } from './get-active-schedule';
import { getActualScheduleStartDate } from './get-actual-schedule-start-date';
import { getScheduleEndDate } from './get-schedule-end-date';
import { normalizeSchedules } from './normalize-schedules';

export type GetScheduleByDateOptions = {
  date: Timestamp;
  today: Timestamp;
};

export const getScheduleByDate = (
  schedules: HabitSchedule[] | undefined | null,
  { date, today }: GetScheduleByDateOptions,
): HabitSchedule | undefined =>
  schedules?.length === 1
    ? schedules[0]
    : normalizeSchedules(schedules ?? []).find((schedule) => {
        const scheduleStartDate = getActualScheduleStartDate(schedule);
        return (
          isAfter(date, scheduleStartDate) &&
          (!schedule.endDate || isBefore(date, getScheduleEndDate(schedule)!))
        );
      }) ?? getActiveSchedule(schedules, today);
